var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextBalloon = function SvgIconTextBalloon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.442 5.288a7 7 0 0 0-3.736-3.744A6.9 6.9 0 0 0 8 1h-.031a6.95 6.95 0 0 0-4.935 2.069A7 7 0 0 0 1.55 5.3a7.041 7.041 0 0 0 .214 5.856v2.375c0 .397.322.719.717.719h2.372A7 7 0 0 0 7.97 15h.033c.935 0 1.84-.181 2.692-.536a6.9 6.9 0 0 0 2.227-1.487 7 7 0 0 0 1.505-2.22 7 7 0 0 0 .559-2.726 7 7 0 0 0-.544-2.743M4.882 8.75a.75.75 0 0 1 0-1.5.75.75 0 0 1 0 1.5M8 8.75a.75.75 0 0 1 0-1.5.75.75 0 0 1 0 1.5m3.119 0a.75.75 0 0 1 0-1.5.75.75 0 0 1 0 1.5"
  })));
};
export default SvgIconTextBalloon;